import * as React from "react";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { getBundleProductTitle } from "../../../../utils/utils/get-bundle-product-title.js";
import { ConfigurationSummaryRow } from "../../ConfigurationSummaryRow/components/ConfigurationSummary/ConfigurationSummaryRow/ConfigurationSummaryRow.js";
/* empty css                          */
const PRICE_PREFIX = "+";
const ConfigurationSummary = ({
  frame,
  addOn,
  lensType,
  lensPackage,
  bundlePrice,
  hasVisitedStepLensPackage,
  hasVisitedStepAddOn,
  totalPricePrefix,
  minimumBundleSupplement
}) => {
  const { getLabel } = useIntl();
  const labels = {
    frame: getLabel("products.glasses.configurator.frame"),
    lensType: getLabel("products.glasses.configurator.lensType"),
    lensPackage: getLabel("products.glasses.configurator.lensPackage"),
    addOn: getLabel("products.glasses.configurator.addOn"),
    totalPrice: getLabel("products.glasses.configurator.totalPrice"),
    zeroPrice: getLabel("products.glasses.configurator.priceIsZero"),
    minimumBundleSupplement: getLabel("products.glasses.configurator.minimumBundleSupplement", {
      hideLabelKey: true
    })
  };
  return /* @__PURE__ */ React.createElement("section", { className: "configuration-summary" }, frame && /* @__PURE__ */ React.createElement(
    ConfigurationSummaryRow,
    {
      className: "configuration-summary__row",
      label: labels.frame,
      labelVariant: "body-head",
      value: frame.title,
      price: frame.price
    }
  ), lensType && /* @__PURE__ */ React.createElement(
    ConfigurationSummaryRow,
    {
      className: "configuration-summary__row",
      label: labels.lensType,
      value: getBundleProductTitle(lensType),
      price: lensType.price,
      pricePrefix: PRICE_PREFIX,
      discountText: lensType.discountText,
      step: "lensType",
      "data-t": "configuration-summary-row-lens-type"
    }
  ), hasVisitedStepLensPackage && lensPackage && /* @__PURE__ */ React.createElement(
    ConfigurationSummaryRow,
    {
      className: "configuration-summary__row",
      label: labels.lensPackage,
      value: lensPackage.title,
      price: lensPackage.price,
      pricePrefix: PRICE_PREFIX,
      discountText: lensPackage.discountText,
      step: "lensPackage",
      "data-t": "configuration-summary-row-lens-package"
    }
  ), hasVisitedStepAddOn && addOn && /* @__PURE__ */ React.createElement(
    ConfigurationSummaryRow,
    {
      className: "configuration-summary__row",
      label: labels.addOn,
      value: getBundleProductTitle(addOn),
      price: addOn.price,
      pricePrefix: PRICE_PREFIX,
      discountText: addOn.discountText,
      step: "lensAddOn",
      "data-t": "configuration-summary-row-add-on"
    }
  ), minimumBundleSupplement && /* @__PURE__ */ React.createElement(
    ConfigurationSummaryRow,
    {
      className: "configuration-summary__row",
      label: labels.minimumBundleSupplement,
      price: minimumBundleSupplement,
      pricePrefix: PRICE_PREFIX,
      "data-t": "configuration-summary-row-minimum-supplement"
    }
  ), /* @__PURE__ */ React.createElement(
    ConfigurationSummaryRow,
    {
      className: "configuration-summary__row",
      label: labels.totalPrice,
      labelVariant: "body-head",
      priceTextVariant: "body-head",
      priceSize: "medium",
      price: bundlePrice,
      pricePrefix: /* @__PURE__ */ React.createElement(Text, { variant: "body-head", component: "div" }, totalPricePrefix),
      "data-t": "configuration-summary-row-total-price"
    }
  ));
};
export {
  ConfigurationSummary
};
//# sourceMappingURL=ConfigurationSummary.js.map
